import { FC } from 'react';
import { EditableDataTable, EditableColumn } from '@/components/ui';
import { PerformanceRow } from '../types';

interface PerformanceTabProps {
  description: string;
  legend: {
    news: string;
    company: string;
  };
  rows: PerformanceRow[];
  loading?: boolean;
  error?: string | null;
  pagination?: {
    pageIndex: number;
    pageSize: number;
    totalCount: number;
  };
  onPaginationChange?: (pagination: { pageIndex: number; pageSize: number }) => void;
}

/**
 * Topic Performance Tab Component
 * Shows content performance by category
 */
export const PerformanceTab: FC<PerformanceTabProps> = ({
  description,
  rows,
  loading = false,
  error = null,
  pagination,
  onPaginationChange,
}) => {
  const columns: EditableColumn<PerformanceRow>[] = [
    {
      key: 'category',
      header: 'Category',
      accessor: 'category',
    },
    // {
    //   key: 'type',
    //   header: 'Type',
    //   render: (row) => getTypeBadge(row.type),
    // },
    {
      key: 'min_likes',
      header: 'Min Likes',
      render: (row) => row.min_likes?.toLocaleString() || '0',
    },
    {
      key: 'max_likes',
      header: 'Max Likes',
      render: (row) => row.max_likes?.toLocaleString() || '0',
    },
  ];

  if (loading) {
    return (
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Topic Performance by Category
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            {description}{' '}
            <span className="font-semibold text-blue-600">Blue tags</span> = News-driven,{' '}
            <span className="font-semibold text-green-600">Green tags</span> = Company-driven.
          </p>
        </div>
        <div className="animate-pulse space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-12 bg-gray-200 rounded"></div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Topic Performance by Category
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            {description}{' '}
            <span className="font-semibold text-blue-600">Blue tags</span> = News-driven,{' '}
            <span className="font-semibold text-green-600">Green tags</span> = Company-driven.
          </p>
        </div>
        <div className="text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">
          Topic Performance by Category
        </h2>
        {/* <p className="text-sm text-gray-600 mt-1">
          {description}{' '}
          <span className="font-semibold text-blue-600">Blue tags</span> = News-driven,{' '}
          <span className="font-semibold text-green-600">Green tags</span> = Company-driven.
        </p> */}
      </div>

      {rows.length === 0 && !loading ? (
        <div className="text-gray-500 text-center py-8">
          No performance data available.
        </div>
      ) : (
        <EditableDataTable
          columns={columns}
          data={rows}
          keyExtractor={(_, idx) => `performance-${idx}`}
          enableEditing={true}
          pagination={pagination}
          onPaginationChange={onPaginationChange}
          loading={loading}
        />
      )}
    </div>
  );
};
